import React from "react";
import { useNavigate } from "react-router-dom";

import FileUpload from "components/FileUpload/FileUpload";
import { Heading2 } from "widgets";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import FileUploadsHistory from "components/FileUploadsHistory/FileUploadsHistory";
import { UPLOAD_FEATURE_OFFERINGS_TO_PACKAGES_SCRIPT_ID } from "constants/constants";

import styles from "./UploadFeatureOfferings.module.scss";

const handleOnClickGoBackButton = (navigate) => {
  navigate("/homePage");
};

const UploadFeatureOfferings = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.mainContainer}>
      <div
        className={styles.backContainer}
        onClick={() => handleOnClickGoBackButton(navigate)}
      >
        <ArrowBackIosIcon className={styles.icon} />
        <span className={styles.text}>Back</span>
      </div>
      <Heading2 heading="Upload Feature Offerings to Package" />
      <FileUpload scriptId={UPLOAD_FEATURE_OFFERINGS_TO_PACKAGES_SCRIPT_ID} uploadLabel="Upload Feature Offerings" />
      <Heading2 heading="Recently Uploaded Feature Offerings to Packages" />
      <FileUploadsHistory scriptId={UPLOAD_FEATURE_OFFERINGS_TO_PACKAGES_SCRIPT_ID} />
    </div>
  );
};
export default UploadFeatureOfferings;
